const Instructions = () => {
  return <div className="flex-column gap-grid column-start w-100"></div>;
};

export default Instructions;
